export const checkData = (obj) => {
    for (let key in obj) {
        if (obj[key].length == 0) {
            delete obj[key];
        }
    }
    return obj;
}